/* Learning Library only: omit the exact editorial note requested by the merchant. */
(() => {
  'use strict';
  if (window.__patinaLearnCopy25) return;
  window.__patinaLearnCopy25 = true;

  const note = 'Editorial imagery may show developed patina or illustrative scenes. Product listings—not these illustrations—describe the exact item, its starting condition and what is included.';
  const selector = 'p, aside, div, small, figcaption';
  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim();
  let observer;
  let observedScope;

  function removeNote(node) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element || !element.isConnected) return;
    const candidates = [];
    if (element.matches(selector)) candidates.push(element);
    candidates.push(...element.querySelectorAll(selector));
    for (const candidate of candidates) {
      if (!candidate.isConnected || candidate.closest('script, style, template, [contenteditable]')) continue;
      if (normalize(candidate.textContent) !== note) continue;
      // Do not remove an unrelated control or media element that shares a wrapper.
      if (candidate.querySelector('button, input, select, textarea, form, img, video, iframe')) continue;
      candidate.remove();
    }
  }

  function initialize() {
    const page = document.querySelector('[data-ps24-page="learn"]');
    if (!page) {
      observer?.disconnect();
      observedScope = null;
      return;
    }
    const scope = page.closest('.page-wrapper') || page.closest('main') || page;
    removeNote(scope);
    if (scope === observedScope) return;
    observer?.disconnect();
    observedScope = scope;
    observer = new MutationObserver(records => {
      if (!page.isConnected) {
        observer.disconnect();
        observedScope = null;
        return;
      }
      for (const record of records) {
        for (const node of record.addedNodes) removeNote(node);
      }
    });
    observer.observe(scope, {childList: true, subtree: true});
  }

  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {once: true});
  } else {
    initialize();
  }
})();
